module.exports = __webpack_public_path__ + "static/icon-app-store-b36bcf724bc71f295292ea1fbf066aa1.svg";